import React from 'react';
import Breadcrumb from 'react-bootstrap/Breadcrumb';

class SettingsHead extends React.Component {
  render() {
    return (
      <div className="settings-head">
        <div className="shape shape-left"></div>
        <div className="shape shape-right"></div>
        <div className="container head-container">
          <Breadcrumb className="top-header">
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item active>Settings</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>
    );
  }
}

export default SettingsHead;
